import script from "./PointStyleUI.vue?vue&type=script&setup=true&lang=js"
export * from "./PointStyleUI.vue?vue&type=script&setup=true&lang=js"

import "./PointStyleUI.vue?vue&type=style&index=0&id=6e27e57a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e27e57a"]])

export default __exports__